import React from 'react';
import PropTypes from 'prop-types';
import BullhornOutlineIcon from 'mdi-react/BullhornOutlineIcon';
import ViewCarouselIcon from 'mdi-react/ViewCarouselIcon';
import GestureTapIcon from 'mdi-react/GestureTapIcon';
import CalendarClockIcon from 'mdi-react/CalendarClockIcon';
import ShieldAccountOutlineIcon from 'mdi-react/ShieldAccountOutlineIcon';
import TagOutlineIcon from 'mdi-react/TagOutlineIcon';
import ChartBarIcon from 'mdi-react/ChartBarIcon';
import { partial } from '../../../util/translation/translation';
import FeatureShowcase from '../../../shared/components/custom/FeatureShowcase';
import SpotlightPhonePreview from './SpotlightPhonePreview';
import { exampleImage } from '../../users/components/SegmentsShowcase';

const OPEN_ACCESS = { group: null, level: null, tier: null };

/**
 * Spotlight in two steps: a group (its size and format, placed on a screen
 * in App layout), then its tiles, each leading to something in the app,
 * with a schedule, an audience and a label.
 */
const SpotlightShowcase = ({ collapsible, action }) => {
  const s = partial('shared');
  const exampleTile = (key, title, text) => ({
    key,
    tile: {
      title,
      description: text,
      headingImage: { preview: exampleImage(title) },
    },
    access: OPEN_ACCESS,
  });
  return (
    <FeatureShowcase
      storageKey="spotlightShowcaseHidden"
      icon={BullhornOutlineIcon}
      title={s('spotlightInfoTitle')}
      subtitle={s('spotlightShowcaseSubtitle')}
      showLabel={s('spotlightShowcaseShow')}
      uses={[
        {
          key: 'group',
          step: s('showcaseStep', { step: 1 }),
          icon: ViewCarouselIcon,
          label: s('spotlightGroupLabel'),
          text: s('spotlightGroupText'),
          // A group as the app shows it: a row of tiles
          preview: (
            <SpotlightPhonePreview
              group={{
                format: 'LANDSCAPE',
                size: 'MEDIUM',
                title: s('spotlightExampleGroup'),
                titleVisible: true,
                descriptionAvailable: true,
              }}
              tiles={[
                exampleTile(
                  'match',
                  s('spotlightExampleMatch'),
                  s('spotlightExampleMatchText')
                ),
                exampleTile(
                  'offer',
                  s('spotlightExampleOffer'),
                  s('spotlightExampleOfferText')
                ),
              ]}
            />
          ),
        },
        {
          key: 'tiles',
          step: s('showcaseStep', { step: 2 }),
          icon: GestureTapIcon,
          label: s('spotlightTilesLabel'),
          text: s('spotlightTilesText'),
          cards: [
            {
              key: 'schedule',
              icon: CalendarClockIcon,
              title: s('spotlightCardSchedule'),
              text: s('spotlightCardScheduleText'),
            },
            {
              key: 'access',
              icon: ShieldAccountOutlineIcon,
              title: s('spotlightCardAccess'),
              text: s('spotlightCardAccessText'),
            },
            {
              key: 'label',
              icon: TagOutlineIcon,
              title: s('spotlightCardLabel'),
              text: s('spotlightCardLabelText'),
            },
            {
              key: 'clicks',
              icon: ChartBarIcon,
              title: s('spotlightCardClicks'),
              text: s('spotlightCardClicksText'),
            },
          ],
        },
      ]}
      collapsible={collapsible}
      action={action}
    />
  );
};

SpotlightShowcase.propTypes = {
  collapsible: PropTypes.bool,
  action: PropTypes.node,
};

SpotlightShowcase.defaultProps = {
  collapsible: true,
  action: null,
};

export default SpotlightShowcase;
